import React from 'react';

import ListingCollection from '../../../../components/ListingCollection/ListingCollection';

import SectionContainer from '../SectionContainer';
import css from './SectionListingCollection.module.css';

/**
 * Section that renders a listing collection (a carousel of listing cards) inside a
 * hosted page. The listings themselves are fetched in the page's loadData, so this
 * section renders on the server too.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName overwrite component's own css.root
 * @param {string} props.sectionId id of the section
 * @param {'listingCollection'} props.sectionType
 * @param {Object} props.collection collection config (id, titleKey, limit)
 * @param {Object?} props.appearance
 * @returns {JSX.Element}
 */
const SectionListingCollection = props => {
  const { sectionId, className, rootClassName, collection, appearance } = props;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
    >
      <ListingCollection className={css.collection} collection={collection} />
    </SectionContainer>
  );
};

export default SectionListingCollection;
